import { DirectoryIcon } from "@icons";
import styles from "./RefGlyph.module.scss";

export const CounterpartyGlyph = () => (
    <DirectoryIcon className={styles.glyph} aria-hidden />
);
